export const ROUTES = {
  default: "/",
  projects: "/projects",
  experience: "/experience",
  about: "/about",
}
